"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _helpers = require("../../helpers");
var _ResourceSelector = _interopRequireDefault(require("../ResourceSelector.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Certificate = function Certificate(_ref) {
  var certificates = _ref.certificates,
    deleteCertificate = _ref.deleteCertificate,
    index = _ref.index,
    name = _ref.name;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    firstLoad = _useState2[0],
    setFirstLoad = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    showEditors = _useState4[0],
    setShowEditors = _useState4[1];

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE-RELATED //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    if (firstLoad) {
      setFirstLoad(false);
    } else {
      // We must briefly remove the TinyMCE editors to allow the content to change
      setShowEditors(false);
      // Render the TinyMCE editors again in a short time
      setTimeout(function () {
        return setShowEditors(true);
      }, 50);
    }
  }, [certificates.length]);

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  var deleteCertificateButton = !certificates || certificates.length < 2 ? null : /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Delete Certificate"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-xs btn-danger ".concat(_style["default"].deleteButton),
    onClick: deleteCertificate
  }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));
  var headerInfo = !certificates || certificates.length < 2 ? null : /*#__PURE__*/_react["default"].createElement("h4", null, "Certificate ", index + 1);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].certificateContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerInfo
  }, headerInfo, deleteCertificateButton), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    component: _cccisdFormik.CccisdInput,
    label: "Course Name",
    name: "".concat(name, ".courseName")
  }), showEditors && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    component: _cccisdFormik.CccisdWysiwyg,
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: "Free Text",
      tooltip: "Appears below Course Name. E.g., '3.5 Hours of C.E. Credit'."
    }),
    name: "".concat(name, ".freeText"),
    type: "input"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    component: _ResourceSelector["default"],
    label: "Certificate Image",
    name: "".concat(name, ".backgroundId")
  }), showEditors && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    component: _cccisdFormik.CccisdWysiwyg,
    label: "Accreditation Statement 1",
    name: "".concat(name, ".accreditation1"),
    type: "textarea"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    component: _cccisdFormik.CccisdWysiwyg,
    label: "Accreditation Statement 2",
    name: "".concat(name, ".accreditation2"),
    type: "textarea"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    component: _cccisdFormik.CccisdWysiwyg,
    label: "Accreditation Statement 3",
    name: "".concat(name, ".accreditation3"),
    type: "textarea"
  })));
};
Certificate.propTypes = {
  certificates: _propTypes["default"].array,
  deleteCertificate: _propTypes["default"].func,
  index: _propTypes["default"].number,
  name: _propTypes["default"].string
};
var _default = exports["default"] = Certificate;